import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import theme from "../../theme";
import RichTextEditor from "react-rte";
import CommonEditor from "../../common/components/CommonEditor";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { createStaticPage, getStaticPage, updateStaticPage } from "../../api/staticPageApi";
import { StaticPageType } from "../../common/const";
import CommonButton from "../../common/components/CommonButton";

const ManagePage = () => {
    const { loading } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = React.useState(0);
    const [value, setValue] = useState('');
    const [content, setContent] = useState(RichTextEditor?.createValueFromString(value || '', 'html'));
    const [pageId, setPageId] = useState(null);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const getPage = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const pageType = activeTab === 0 ? StaticPageType.ABOUT : activeTab === 1 ? StaticPageType.TERMS : StaticPageType.PRIVACY
            const response = await getStaticPage(pageType);
            const { page_id, content_html } = response?.data;
            setPageId(page_id);
            setContent(RichTextEditor?.createValueFromString(content_html || '', 'html'))
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            setPageId(null);
            setContent(RichTextEditor?.createValueFromString('', 'html'))
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            if (errorMessage !== 'Static Page not found') {
                showNotification(errorMessage, 'error');
            }
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getPage();
    }, [activeTab]);

    const saveContent = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            let response;
            const data = {
                "page_type": activeTab === 0 ? StaticPageType.ABOUT : activeTab === 1 ? StaticPageType.TERMS : StaticPageType.PRIVACY,
                "title": activeTab === 0 ? `${StaticPageType.ABOUT} Page` : activeTab === 1 ? `${StaticPageType.TERMS} Page` : `${StaticPageType.PRIVACY} Page`,
                "content_html": content?._cache?.html,
                "version": 1,
                "status": "PUBLISHED"
            }
            if (pageId) {
                response = await updateStaticPage(pageId, data);
            } else {
                response = await createStaticPage(data);
            }
            if (response.success) {
                showNotification(response.message, 'success');
                getPage();
                dispatch(setLoading({
                    loading: false
                }));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <Typography fontSize={20} fontWeight={600}>
                Manage Content
            </Typography>
            <Box sx={{ width: '100%' }} mb={1}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: theme.palette.secondary.main, // Selected tab border bottom color
                                height: 2, // Optional: adjust indicator height
                            }
                        }}
                    >
                        <Tab
                            label="About Us"
                            value={0}
                            sx={{
                                color: theme.palette.secondary.main, // Default tab text color
                                '&.Mui-selected': {
                                    color: theme.palette.secondary.main, // Selected tab text color
                                },
                                '&:hover': {
                                    color: theme.palette.secondary.main // Hover color (optional)
                                }
                            }}
                        />
                        <Tab
                            label="Terms & Conditions"
                            value={1}
                            sx={{
                                color: theme.palette.secondary.main, // Default tab text color
                                '&.Mui-selected': {
                                    color: theme.palette.secondary.main, // Selected tab text color
                                },
                                '&:hover': {
                                    color: theme.palette.secondary.main // Hover color (optional)
                                }
                            }}
                        />
                        <Tab
                            label="Privacy Policy"
                            value={2}
                            sx={{
                                color: theme.palette.secondary.main, // Default tab text color
                                '&.Mui-selected': {
                                    color: theme.palette.secondary.main, // Selected tab text color
                                },
                                '&:hover': {
                                    color: theme.palette.secondary.main // Hover color (optional)
                                }
                            }}
                        />
                    </Tabs>
                </Box>
            </Box>
            <CommonEditor
                placeholder="Enter the content"
                value={content}
                setValue={(value) => {
                    setValue(value.toString('html'));
                    setContent(value);
                }}
            />
            <Box sx={{ float: 'right ' }}>
                <CommonButton
                    label="Update Changes"
                    marginBottom="0px"
                    marginTop={2}
                    width="170px"
                    color="White"
                    background={theme.palette.secondary.main}
                    handleClick={() => saveContent()}
                />
            </Box>
        </Fragment>
    )
}

export default ManagePage;